import i18next  from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'leftContainer', es);
i18next.addResourceBundle('en', 'leftContainer', en);
i18next.addResourceBundle('pt', 'leftContainer', pt);